import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

// Resolves "current antardasha" to its concrete index and redirects.
export default function CurrentAntardashaRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/journey/antardasha-map").then(r => {
      const idx = r.data.current_index >= 0 ? r.data.current_index : 0;
      navigate(`/app/journey/antardasha/${idx}`, { replace: true });
    }).catch(() => navigate("/app/journey", { replace: true }));
  }, [navigate]);

  return (
    <div className="flex items-center justify-center py-24">
      <span className="animate-soft-pulse" style={{ color: "var(--vedari-ink-soft)" }}>A moment…</span>
    </div>
  );
}
